(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cubrider-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cr-reviews').forEach((section) => {
    const button = section.querySelector('[data-review-load]');
    if (!button) return;
    button.addEventListener('click', () => {
      section.querySelectorAll('.is-review-hidden').forEach((card) => card.classList.remove('is-review-hidden'));
      button.remove();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydrave-header"] && !Shopify.designMode) return;
  try {
    
function initHydraveAnnouncements(scope){scope.querySelectorAll('[data-hv-announcement]').forEach(bar=>{if(bar.dataset.ready)return;bar.dataset.ready='true';const button=bar.querySelector('[data-hv-announcement-pause]');button.hidden=false;button.addEventListener('click',()=>{const paused=bar.dataset.paused!=='true';bar.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);});});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initHydraveAnnouncements(document));else initHydraveAnnouncements(document);
document.addEventListener('shopify:section:load',event=>initHydraveAnnouncements(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydrave-reviews"] && !Shopify.designMode) return;
  try {
    
function initHydraveReviews(scope){scope.querySelectorAll('[data-hv-reviews]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const list=root.querySelector('[data-review-list]');const cards=Array.from(list.children);let shown=12;const more=root.querySelector('[data-review-more]');const update=()=>{Array.from(list.children).forEach((card,index)=>card.hidden=index>=shown);root.querySelector('[data-review-shown]').textContent=String(Math.min(shown,cards.length));more.hidden=shown>=cards.length;};root.querySelectorAll('[data-review-controls]').forEach(el=>el.hidden=false);root.querySelector('[data-review-sort]').addEventListener('change',event=>{const order=event.target.value;const sorted=[...cards].sort((a,b)=>order==='newest'?Number(b.dataset.date)-Number(a.dataset.date):order==='highest'?Number(b.dataset.rating)-Number(a.dataset.rating):order==='lowest'?Number(a.dataset.rating)-Number(b.dataset.rating):Number(a.dataset.sourceOrder)-Number(b.dataset.sourceOrder));sorted.forEach(card=>list.append(card));shown=12;update();});more.addEventListener('click',()=>{shown+=12;update();});update();});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initHydraveReviews(document));else initHydraveReviews(document);
document.addEventListener('shopify:section:load',event=>initHydraveReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
